// extracted by mini-css-extract-plugin
module.exports = {"root":"WV3zC"};